module.exports = __webpack_public_path__ + "static/media/workingmemory-words-3.64c88f01.mp3";